/**
 * Core Web Vitals en producción.
 *
 * Envía LCP, INP, CLS, FCP y TTFB al `dataLayer` de Google Tag Manager, que ya está
 * cargado en public/index.html. No añade ningún SDK nuevo al bundle inicial:
 * `web-vitals` se importa de forma diferida y pesa ~2 KB.
 *
 * En GTM hay que crear una vez:
 *   - Trigger "Evento personalizado" con nombre `web_vitals`.
 *   - Tag GA4 "Evento" con nombre `web_vitals` y parámetros
 *     metric_name, metric_value, metric_rating, metric_id, page_path, user_rol.
 * Pasos completos en docs/manual-observabilidad.md.
 *
 * El valor de CLS se multiplica por 1000 porque GA4 prefiere enteros; en el reporte
 * se divide de vuelta. Las demás métricas van en milisegundos.
 */
const isPrerender = typeof navigator !== "undefined" && /ReactSnap/i.test(navigator.userAgent);

export const sendToDataLayer = (metric) => {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "web_vitals",
    metric_name: metric.name,
    metric_value: Math.round(metric.name === "CLS" ? metric.value * 1000 : metric.value),
    metric_delta: Math.round(metric.name === "CLS" ? metric.delta * 1000 : metric.delta),
    metric_rating: metric.rating,
    metric_id: metric.id,
    navigation_type: metric.navigationType,
    page_path: window.location.pathname,
  });
};

const reportWebVitals = (onPerfEntry = sendToDataLayer) => {
  if (isPrerender || typeof onPerfEntry !== "function") return;
  import("web-vitals").then(({ onCLS, onINP, onLCP, onFCP, onTTFB }) => {
    onCLS(onPerfEntry);
    onINP(onPerfEntry);
    onLCP(onPerfEntry);
    onFCP(onPerfEntry);
    onTTFB(onPerfEntry);
  });
};

export default reportWebVitals;
